import { NewsItemModel } from '../../../../api-service/clients';
import { IFilterValues } from '../../../../components/data-grid/fasit-data-grid-toolbar';

export const allAuthors = '';
export const ownAuthor = '@bruger';

export function authorFilterOptions(newsItems: NewsItemModel[], caseworkerName: string): IFilterValues[] {
  const otherAuthors = [...new Set(newsItems.map(newsItem => newsItem.author ?? ''))]
    .filter(author => author && author !== caseworkerName)
    .sort((a, b) => a.localeCompare(b, 'da'));

  return [
    { value: allAuthors, text: 'Alle' },
    ...(caseworkerName ? [{ value: ownAuthor, text: ownAuthor }] : []),
    ...otherAuthors.map(author => ({ value: author, text: author })),
  ];
}

export function isWrittenBy(newsItem: NewsItemModel, authorFilter: string, caseworkerName: string) {
  if (authorFilter === allAuthors) {
    return true;
  }
  if (authorFilter === ownAuthor) {
    return !!caseworkerName && newsItem.author === caseworkerName;
  }
  return newsItem.author === authorFilter;
}
